import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { adminGuard } from './classes/_guards/admin.guard';
import { authGuard } from './classes/_guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./user-login/user-login.component').then(m => m.UserLoginComponent)
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./user-registration/user-registration.component').then(m => m.UserRegistration)
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./oauth-callback/oauth-callback.component').then(m => m.OauthCallbackComponent)
  },
  {
    path: 'confirm-registration/:username',
    loadComponent: () =>
      import('./user-registration/confirm-user-registration/confirm-user-registration.component').then(
        m => m.ConfirmUserRegistrationComponent
      )
  },
  {
    path: 'forgot-password/:email',
    loadComponent: () =>
      import('./forgot-user-password/forgot-user-password.component').then(
        m => m.ForgotUserPasswordComponent
      )
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./forgot-user-password/forgot-user-password-verification/forgot-user-password-verification.component').then(
        m => m.ForgotUserPasswordVerificationComponent
      )
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import('./change-user-password/change-user-password.component').then(
        m => m.ChangeUserPasswordComponent
      ),
    canActivate: [authGuard]
  },
  {
    path: 'live-alerts',
    loadComponent: () =>
      import('./live-alerts/live-alerts.component').then(m => m.LiveAlertsComponent),
    data: { reuseComponent: true },
    canActivate: [authGuard]
  },
  {
    path: 'sensor-health',
    loadComponent: () =>
      import('./sensor-dashboard/sensor-dashboard.component').then(m => m.SensorDashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'pump-dashboard',
    loadComponent: () =>
      import('./pump-dashboard/pump-dashboard.component').then(m => m.PumpDashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'alert-overview-dashboard',
    loadComponent: () =>
      import('./alert-overview-dashboard/alert-overview-dashboard.component').then(
        m => m.AlertOverviewDashboardComponent
      ),
    canActivate: [authGuard]
  },
  {
    path: 'spill-preds',
    loadComponent: () =>
      import('./spill-preds/spill-preds.component').then(m => m.SpillPredsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'csa-dashboard',
    loadComponent: () =>
      import('./csa-dashboard/csa-dashboard.component').then(m => m.CsaDashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'map-view',
    loadComponent: () => import('./map-view/map-view.component').then(m => m.MapViewComponent),
    canActivate: [authGuard]
  },
  {
    path: 'network-performance',
    loadComponent: () =>
      import('./network-visualisation/network-visualisation.component').then(
        m => m.NetworkVisualisationComponent
      ),
    canActivate: [authGuard]
  },
  {
    path: 'all-sites',
    loadComponent: () => import('./all-sites/all-sites.component').then(m => m.AllSitesComponent),
    canActivate: [authGuard]
  },
  {
    path: 'triage-view',
    loadComponent: () =>
      import('./triage-view/triage-view.component').then(m => m.TriageViewComponent),
    canActivate: [authGuard]
  },
  {
    path: 'siteSPS/:name',
    loadComponent: () => import('./site/site.component').then(m => m.SiteComponent),
    canActivate: [authGuard]
  },
  {
    path: 'siteCSO/:name',
    loadComponent: () => import('./site/site.component').then(m => m.SiteComponent),
    canActivate: [authGuard]
  },
  {
    path: 'siteWWTW/:name',
    loadComponent: () => import('./site/site.component').then(m => m.SiteComponent),
    canActivate: [authGuard]
  },
  {
    path: 'siteMH/:name',
    loadComponent: () => import('./site/site.component').then(m => m.SiteComponent),
    canActivate: [authGuard]
  },
  {
    path: 'siteST/:name',
    loadComponent: () => import('./site/site.component').then(m => m.SiteComponent),
    canActivate: [authGuard]
  },
  {
    path: 'siteGULLY/:name',
    loadComponent: () => import('./site/site.component').then(m => m.SiteComponent),
    canActivate: [authGuard]
  },
  {
    path: 'siteGLY/:name',
    redirectTo: 'siteGULLY/:name'
  },
  {
    path: 'facility/:name',
    loadComponent: () => import('./facility/facility.component').then(m => m.FacilityComponent),
    canActivate: [authGuard]
  },
  {
    path: 'treatment-works',
    loadComponent: () => import('./treatment-works/treatment-works.component').then(m => m.TreatmentWorksComponent),
    canActivate: [authGuard]
  },
  {
    path: 'admin',
    loadComponent: () => import('./admin/admin.component').then(m => m.AdminComponent),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'logout',
    loadComponent: () => import('./logout/logout.component').then(m => m.LogoutComponent)
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
